import { occupationCredentialEntityName, } from '../../backend/config/classifiers/entities/defineOccupationCredentialClassifier';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
export function useOccupationCredentialStorage() {
    return useStorageClient(occupationCredentialEntityName);
}
